import { React, useState , useEffect} from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import CancelIcon from "@mui/icons-material/Cancel";
import Image from "../../../../images/otpModal.png";
import { InputAdornment, TextField } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { setAuthToken } from "../../../../utils/setAuthToken";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ForgotEnterOtpModal from "./otpModalFP";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 525,
  width: "100%",
  "@media(max-width:600px)":{width:"303px!important"},
  minWidth: "303px!important",
  bgcolor: "#FFFFFF",
  borderRadius: "24px",
  boxShadow: 24,
  p: "1rem 1.4rem ",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

export default function ForgotEmailModal(props) {
  //Normal use states
  const [email, setEmail] = useState("");

  const navigate = useNavigate();
  // Modal use State
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  //backdrop usestates
  const [openbackdrop, setOpenbackdrop] = useState(false);
  const handleClosebd = () => {
    setOpenbackdrop(false);
  };
  const handleOpenbd = () => {
    setOpenbackdrop(true);
  };
  

  const initiateForgotEmail = (e) => {
    e.preventDefault();
    handleOpenbd();
    // setAuthToken(localStorage.getItem("tempToken"));
    axios
      .post("https://api.blockpay.co.za/forgotpassword/initiateForgotPassword", {
        email: email,
      })
      .then((res) => {
        toast.success(res.data.message);
        localStorage.setItem("tempToken",res.data.token)
        handleClosebd();
        handleOpen();
        console.log(res);
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        setTimeout(() => {
          handleClosebd();
        }, 100);
        if (err.response.data.message == "Unauthorized!") {
          localStorage.clear();
          navigate("/signinpin", { replace: true });
        }
        console.log(err);
      });
  };

  useEffect(() => {
  }, []);
  return (
    <div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 999 }}
        open={openbackdrop}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ToastContainer />
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        {...props}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={props.open}>
          <Box sx={style}>
            <Box
              sx={{
                color: "#919191",
                marginLeft: "auto",
              }}
              onClick={props.onClose}
            >
              <CancelIcon />
            </Box>
            <Box
              component="img"
              src={Image}
              sx={{ height: "200px", width: "230px" }}
            />
            <Typography
              id="transition-modal-title"
              variant="h5"
              component="h2"
              sx={{ fontWeight: "500", lineHeight: "2.421rem" }}
            >
              Forgot Password ?
            </Typography>
            <Typography
              id="transition-modal-description"
              sx={{
                mt: 1,
                mb: 2,
                fontSize: "16px!important",
                color: "#626262",
                textAlign: "center",
              }}
            >
              Enter your email!
            </Typography>
            <TextField
              id="email"
              className="logintextField"
              label="Email address"
              InputLabelProps={{ shrink: true }}
              variant="outlined"
              type="email"
              onChange={(e) => setEmail(e.target.value)}
              required
             
            />

            <Button
              className="loginButtonSignUp"
              variant="contained"
              color="primary"
              size="large"
              type="submit"
              onClick={initiateForgotEmail}
              disabled={email === ""}
              sx={{ textTransform: "none", borderRadius: "10px", mb: "1rem" }}
            >
              <span className="buttonSignText">Verify Email</span>
            </Button>
          </Box>
        </Fade>
      </Modal>
      <ForgotEnterOtpModal open={open} onClose={handleClose} email={email} />
    </div>
  );
}
